import { Button } from '@app/components/various/Button';
import { Status } from '@app/components/various/Status';
import { getIsOrderEditable } from '@app/logic/Orders';
import { compiledPaths, paths } from '@app/paths';
import { useModalVisibility, useOrderStatusLabel } from '@app/utils/hooks';
import { Order } from '@typings';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface Props {
  orderDetails: Order.Single;
}

export const CheckoutThankMessage = ({ orderDetails }: Props) => {
  const { t } = useTranslation(['checkout', 'common', 'selections']);

  const { showModal: showCreateSelectionModal } = useModalVisibility('CreateOrderModal');
  const statusLabel = useOrderStatusLabel(orderDetails.order.status);
  const isEditable = getIsOrderEditable(orderDetails.order.status);

  return (
    <div className="py-8">
      <h2 className="mb-5 heading-1">{t('checkout:thank_you_order')}</h2>
      <div className="mb-5 flex w-full flex-col gap-2 text-neutral-40">
        <div className="inline-flex items-center gap-2">
          <p className="body-4">{t('checkout:order_has_status', { status: statusLabel.toLowerCase() })}</p>
          <span className="inline-flex items-center gap-1">
            <Status type={orderDetails.order.status} />
            <span className="text-neutral-20 body-4">{statusLabel}</span>
          </span>
        </div>
        {orderDetails.order.status === 'checkoutRequested' && <p className="body-4">{t('checkout:checkout_requested_info')}</p>}
        {orderDetails.order.status === 'pending' && <p className="body-4">{t('checkout:checkout_pending_info')}</p>}
      </div>
      <div className="flex flex-col flex-wrap gap-2 xs:flex-row">
        <Button onClick={showCreateSelectionModal}>{t('selections:create_new_selection')}</Button>
        {isEditable && (
          <Button as={Link} to={compiledPaths.SELECTION_DETAILS({ id: orderDetails.order.order })} variant="bordered" color="secondary">
            {t('selections:edit_selection')}
          </Button>
        )}
        <Button as={Link} to={paths.SELECTIONS} variant="bordered" color="secondary">
          {t('selections:go_to_selections')}
        </Button>
      </div>
    </div>
  );
};
